var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 30,
    height: 30,
    rx: 15,
    transform: "rotate(90 30 0)",
    fill: "#FFCD0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8032 14.142H7.62314C7.279 14.142 7 14.5257 7 14.9991C7 15.4724 7.279 15.8561 7.62314 15.8561H21.8032C22.1473 15.8561 22.4263 15.4724 22.4263 14.9991C22.4263 14.5258 22.1473 14.142 21.8032 14.142Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8032 9H7.62314C7.279 9 7 9.38371 7 9.85702C7 10.3303 7.279 10.714 7.62314 10.714H21.8032C22.1473 10.714 22.4263 10.3303 22.4263 9.85702C22.4263 9.38371 22.1473 9 21.8032 9Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8032 19.2862H7.62314C7.279 19.2862 7 19.6699 7 20.1433C7 20.6166 7.279 21.0003 7.62314 21.0003H21.8032C22.1473 21.0003 22.4263 20.6166 22.4263 20.1433C22.4263 19.6699 22.1473 19.2862 21.8032 19.2862Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenu);
export default __webpack_public_path__ + "static/media/open-menu.89782d814bf1c1c9ea0e4951e3dde2b2.svg";
export { ForwardRef as ReactComponent };